// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bz9JT","delete":"styles_delete__134Pw","update":"styles_update__3M3u_","add":"styles_add__YnQNz"};